import { memo, ReactElement } from 'react'
import { ProfitSharesListItem } from './profit-shares-list-item'
import { useRecoilValue } from 'recoil'
import { accountProfitSharesIdsState } from '../../states/profit-shares-state'
import { useAccountContext } from '../../contexts/account-context'

interface Props {}

const Component = (props: Props): ReactElement => {
  const accountId = useAccountContext()
  const shares: string[] = useRecoilValue(accountProfitSharesIdsState(accountId || ''))

  const onPageChange = (page: number) => {
    console.log('page', page)
  }

  if (!accountId) {
    return <div style={{ padding: '8px' }}>No account selected</div>
  }

  return (
    <div className="mb-4 mt-4">
      <table className="table table-compact table-zebra w-full mb-4">
        <thead>
          <tr>
            <th>Asset</th>
            <th>Realized</th>
          </tr>
        </thead>
        <tbody>
          {shares.map((item) => (
            <ProfitSharesListItem id={item} accountId={accountId} />
          ))}
        </tbody>
      </table>
      {shares.length === 0 && (
        <div className="alert alert-primary">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="stroke-current flex-shrink-0 w-6 h-6">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>No profits yet</span>
          </div>
        </div>
      )}
      {/*<Flexbox justifyContent="center">*/}
      {/*  <Pagination totalPages={0} page={0} onChangePage={onPageChange} />*/}
      {/*</Flexbox>*/}
    </div>
  )
}

export const ProfitSharesList = memo(Component)